import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { SessionService } from '../../../Util/Session/session.service';
import { SiteTypeFormComponent } from '../site-type-form/site-type-form.component';
import { SiteTypeService } from '../../../Model/SiteType/site-type.service';

@Component({
  selector: 'app-site-type',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule],
  templateUrl: './site-type.component.html',
  styleUrl: './site-type.component.scss'
})
export class SiteTypeComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  TableData: any[] = [];
  // ShiftGroupData: any[] = []

  // ShiftGroupRecord: any[] = []
  private modalService = inject(NgbModal);
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private toast: ToastService,
    private download: DownloadSampleService,
    private sitetype: SiteTypeService,
    private Session: SessionService
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsAdd = true
    // this.common.PageRight.IsDelete = true
    // this.common.PageRight.IsEdit = true
    // this.common.PageRight.IsView = true
    // this.common.PageRight.IsPrint = true
    this.dtoptions = { ...this.common.commonDToptions };
  }
  public User: any = null
  filter = {
    SelectType: 'S',
    SiteTypeMasterId: 0
  }

  ngOnInit(): void {
    this.GetData();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  add(id: number) {
    if ((this.common.PageRight.IsAdd && id == 0) || (this.common.PageRight.IsEdit && id > 0)) {
      const modalRef = this.modalService.open(SiteTypeFormComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.id = id;

      modalRef.result.then((result: any) => {
        if (result) {
          this.GetData();
        }
      }).catch(() => {
        // Modal dismissed
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  GetData() {
    this.isDisabled = true;
    this.sitetype.SiteTypeLoad(this.filter).subscribe({
      next: (response) => {
        this.TableData = Object.values(response.Table);
        this.isDisabled = false;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  excelDownload(){
    this.common.ExcelDump('Site Type', this.TableData);
  }

  // exportToExcel() {
  //   this.isDisabled = true
  //   const data = {
  //     SelectType: 'ShiftGroupMasterExcel',
  //     Year: ''
  //   }
  //   this.download.ESS_ExcelDump(data).subscribe(
  //     data => {
  //       this.ShiftGroupData = data;
  //       if (this.ShiftGroupData.length > 0) {
  //         this.download.exportToExcel(this.ShiftGroupData, "ShiftGroup_data");
  //         this.isDisabled = false
  //       }
  //       else {
  //         this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
  //         this.isDisabled = false
  //       }
  //     });
  // }
  // handleFileInput(event: any): void {
  //   this.ShiftGroupRecord.length = 0;
  //   const files: FileList = event.target.files;
  //   if (files && files.length > 0) {
  //     const file: File = files[0];
  //     const fileType: string | undefined = file.name.split('.').pop();
  //     if (fileType !== 'xlsx' && fileType !== 'xls') {
  //       this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
  //       return;
  //     }
  //     this.processExcelFile(file);
  //     event.target.value = '';
  //   }
  // }
  // processExcelFile(file: File): void {
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     if (event && event.target && event.target.result) {
  //       const binaryString = event.target.result as string;
  //       const workbook = XLSX.read(binaryString, { type: 'binary' });
  //       const sheetName = 'Sheet1';
  //       if (!workbook.SheetNames.includes(sheetName)) {
  //         const errorMessage = 'Sheet1 not found in the uploaded file.';
  //         this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
  //         return;
  //       }
  //       const worksheet = workbook.Sheets[sheetName];
  //       const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
  //       const headerRow = excelData[0];
  //       const headers = headerRow.map((header: string) => header.trim());
  //       const dataRows = excelData.slice(1);

  //       const uniqueshiftgroupIds: Set<number> = new Set();
  //       const shiftgroupNames: Set<string> = new Set();
  //       this.ShiftGroupRecord = [];

  //       for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
  //         const row = dataRows[rowIndex];
  //         const rowData: any = {};

  //         row.forEach((cellData, index) => {
  //           rowData[headers[index]] = cellData;
  //         });

  //         const id = rowData['ESS_ShiftGroupMasterID'];
  //         let shiftgroupName = rowData['ShiftGroupName'].toString();

  //         shiftgroupName = shiftgroupName ? shiftgroupName.trim() : '';

  //         if (id !== 0 && id !== '' && id !== undefined && uniqueshiftgroupIds.has(id)) {
  //           this.toast.show({ message: `Duplicate ESS_ShiftGroupMaster ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
  //           return;
  //         } else {
  //           uniqueshiftgroupIds.add(id);
  //         }

  //         if (shiftgroupName === '' || shiftgroupName === null || shiftgroupName === undefined) {
  //           this.toast.show({ message: `Shift group name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
  //           return;
  //         }
  //         else if (shiftgroupNames.has(shiftgroupName)) {
  //           this.toast.show({ message: `Duplicate Shift Group Name "${shiftgroupName}" found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
  //           return;
  //         } else {
  //           shiftgroupNames.add(shiftgroupName);
  //         }
  //         rowData['ShiftGroupName'] = shiftgroupName;
  //         this.ShiftGroupRecord.push(rowData);
  //         console.log(this.ShiftGroupRecord)
  //       }
  //       this.BulkInsertUpdate(this.ShiftGroupRecord);
  //     } else {
  //       console.error('Failed to read the file.');
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }
  // BulkInsertUpdate(Data: any) {
  //   this.User = this.Session.GetUserDetails();
  //   if (this.ShiftGroupRecord.length === 0) {
  //     this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
  //     return
  //   }
  //   const shiftgroupData = {
  //     SelectType: 'UPLOAD',
  //     ESS_ShiftGroupMasterInsert: Data,
  //     UserID: this.User.UserId,
  //   };
  //   this.shift.ESS_ShiftGroupMaster_BulkInsert(shiftgroupData).subscribe(
  //     data => {
  //       if (data.Error_Code == '01') {
  //         this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
  //       }
  //       else {
  //         this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
  //       }
  //       this.GetData();
  //     },
  //     error => {
  //       console.error('Error:', error);
  //     });
  // }
  // downloadExcel() {
  //   this.download.downloadExcel('ShiftGroupMaster');
  // }

}
